module.exports = __webpack_public_path__ + "static/mark-zuckerberg-dc20f496a9c27ff20745521987ce01d2.jpg";